<template>
  <div class="main-dialog">
    <el-dialog
      :title="title"
      :width="width"
      :top="top"
      :visible="dialogVisible"
      :append-to-body="toBody"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="dialogClose">
      <slot/>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    // 对话框标题
    title: {
      type: String,
      default: ''
    },
    // 对话框宽度
    width: {
      type: String,
      default: '30%'
    },
    // 对话框margin-top
    top: {
      type: String,
      default: '30vh'
    },
    // 对话框显示与否
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 添加到body中
    toBody: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    dialogClose () {
      this.$emit('dialog-close')
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>

<style lang="stylus">
.el-dialog
  border-radius 8px

.el-dialog__header
  position relative
  height 24px
  line-height 24px
  padding 20px
  // border-bottom 1px solid #eee
  // box-shadow 0 2px 2px 0 rgba(0, 0, 0, 0.02)

.el-dialog__title
  position absolute
  left 50%
  top 20px
  transform translateX(-50%)
  font-size 22px
  color #303133
  font-weight bold

.el-dialog__headerbtn
  top 15px

.el-dialog__headerbtn .el-dialog__close
  font-size 24px
  color #E60012
</style>
